@if (survey(); as survey) {
<div class="survey">
  <div class="survey-container">
    <!-- Survey Header -->
    @if (survey.image && survey.question) {
    <div class="survey-header survey-header--with-image">
      <img
        [src]="survey.image.variants.full.url"
        [alt]="('survey.image.alt' | translate) + ': ' + survey.question"
        class="survey-header__image"
        [class.survey-header__image--ended]="survey.status === 'ended'"
      />
      <div class="survey-header__overlay"></div>
      <div class="survey-header__meta">
        <div class="survey-header__status">{{ surveyStatus() | translate }}</div>
        <div class="survey-header__question">{{ survey.question }}</div>
      </div>
    </div>
    } @else if (!survey.image && survey.question) {
    <div class="survey-header survey-header--no-image">
      <div class="survey-header__meta survey-header__meta--no-image">
        <div class="survey-header__status">{{ surveyStatus() | translate }}</div>
        <div class="survey-header__question">{{ survey.question }}</div>
      </div>
    </div>
    }

    <!-- Survey Answers -->
    @if (survey.answers_type) {
    <div class="survey-answers">
      @switch (survey.answers_type) {
      <!-- Text Answers -->
      @case ('text') {
      <div class="survey-answers__text-list">
        @for (answer of survey.answers; track answer.id) {
        <div
          class="text-answer"
          [class.text-answer--clickable]="isUserLoggedIn() && !showAnswers()"
          [class.text-answer--disabled]="!isUserLoggedIn() || showAnswers()"
          [class.text-answer--selected]="userAnswerId() === answer.id"
          (click)="onAnswerClick(answer)"
        >
          @if (isUserLoggedIn() && showAnswers()) {
          <div
            class="text-answer__result-bar"
            [style.max-width.%]="calculatePercentage(answer)"
          ></div>
          }
          <div class="text-answer__content">
            <div class="text-answer__text">{{ answer.content }}</div>
            @if (isUserLoggedIn() && showAnswers()) {
            <div class="text-answer__percentage">{{ calculatePercentage(answer) }}%</div>
            }
          </div>
        </div>
        }
      </div>
      }

      <!-- Player Answers -->
      @case ('player') {
      <div class="survey-answers__resource-grid">
        @for (answer of survey.answers; track answer.id) {
        <div class="resource-answer">
          <div class="resource-answer__image-wrapper">
            @if (answer.resource?.image?.variants?.full?.url) {
            <img
              [src]="answer.resource?.image?.variants?.full?.url"
              [alt]="
                $any(answer.resource)?.last_name || ('survey.answer.player' | translate)
              "
              class="resource-answer__image"
            />
            } @else {
            <app-icon
              name="player-outline"
              class="resource-answer__image-placeholder"
            ></app-icon>
            }
          </div>
          <div class="resource-answer__name">
            {{ $any(answer.resource)?.last_name || '-' }}
          </div>
          @if (isUserLoggedIn() && showAnswers()) {
          <div class="resource-answer__result">
            <div
              class="resource-answer__result-bar"
              [class.resource-answer__result-bar--selected]="userAnswerId() === answer.id"
              [style.max-width.%]="calculatePercentage(answer)"
            >
              <div class="resource-answer__percentage--visible">
                {{ calculatePercentage(answer) }}%
              </div>
            </div>
          </div>
          } @if (isUserLoggedIn() && !showAnswers()) {
          <button class="resource-answer__button" (click)="onAnswerClick(answer)">
            {{ 'survey.button.vote' | translate }}
          </button>
          }
        </div>
        }
      </div>
      }

      <!-- Club Answers -->
      @case ('club') {
      <div class="survey-answers__resource-grid">
        @for (answer of survey.answers; track answer.id) {
        <div class="resource-answer">
          <div class="resource-answer__image-wrapper">
            @if (answer.resource?.image?.variants?.full?.url) {
            <img
              [src]="answer.resource?.image?.variants?.full?.url"
              [alt]="$any(answer.resource)?.name || ('survey.answer.club' | translate)"
              class="resource-answer__image"
            />
            } @else {
            <app-icon
              name="player-outline"
              class="resource-answer__image-placeholder"
            ></app-icon>
            }
          </div>
          <div class="resource-answer__name">
            {{ $any(answer.resource)?.name || '-' }}
          </div>
          @if (isUserLoggedIn() && showAnswers()) {
          <div class="resource-answer__result">
            <div
              class="resource-answer__result-bar"
              [class.resource-answer__result-bar--selected]="userAnswerId() === answer.id"
              [style.max-width.%]="calculatePercentage(answer)"
            >
              <div class="resource-answer__percentage--visible">
                {{ calculatePercentage(answer) }}%
              </div>
            </div>
          </div>
          } @if (isUserLoggedIn() && !showAnswers()) {
          <button class="resource-answer__button" (click)="onAnswerClick(answer)">
            {{ 'survey.button.vote' | translate }}
          </button>
          }
        </div>
        }
      </div>
      } }
    </div>
    }

    <!-- Login Button -->
    @if (!isUserLoggedIn()) {
    <button class="survey-login" (click)="onLoginClick()">
      @if (survey.status === 'ended') {
        {{ 'survey.login.viewResults' | translate }}
      } @else {
        {{ 'survey.login.vote' | translate }}
      }
    </button>
    }
  </div>
</div>
}
